import ListItem from './ListItem';
import { ListItemStyled, SimpleNavigationStyled } from './SimpleNavigation.style';
import Slider from './Slider';
import { useMediaMin } from 'hooks/ui/useMediaMin';
import { FriendlyPagesTypesKeys } from 'types/friendlyUrl';
import { ListedItemPropType } from 'types/simpleNavigation';

const TEST_IDENTIFIER = 'blocks-simplenavigation';

type Props = {
    listedItems: ListedItemPropType[];
    type: FriendlyPagesTypesKeys;
};

export const getSearchResultLinkType = (
    listedItem: ListedItemPropType,
    typeFromProps: FriendlyPagesTypesKeys,
): FriendlyPagesTypesKeys => {
    if (listedItem.__typename === 'Article') {
        return 'article';
    }
    if (listedItem.__typename === 'BlogArticle') {
        return 'blogArticle';
    }

    return typeFromProps;
};

const SimpleNavigation: FC<Props> = ({ listedItems, type }) => {
    const isTabletOrDesktop = useMediaMin('lg');

    return (
        <div>
            {isTabletOrDesktop ? (
                <SimpleNavigationStyled data-testid={TEST_IDENTIFIER}>
                    {listedItems.map((listedItem, key) => (
                        <ListItemStyled key={key} data-testid={TEST_IDENTIFIER + '-' + key}>
                            <ListItem type={getSearchResultLinkType(listedItem, type)} listedItem={listedItem}>
                                {listedItem.name}
                            </ListItem>
                        </ListItemStyled>
                    ))}
                </SimpleNavigationStyled>
            ) : (
                <Slider type={type} listedItems={listedItems} />
            )}
        </div>
    );
};

export default SimpleNavigation;
